import { AdminMiniData } from './admin';
import { Counts, Error } from './data';

export class Dealslip {
  success: true | false;
  error: Error;
  results: string;
  counts: Counts;
  filters: DealslipSearchFilters;
  data: DealslipData[] = [];

  constructor() {
    this.filters = new DealslipSearchFilters();
  }
}

export class OneDealslip {
  success: true | false;
  error: Error;
  results: string;
  data: DealslipData;

  constructor() {
    this.data = new DealslipData();
  }
}

export class DealslipDashboard {
  success: true | false;
  error: Error;
  results: string;
  filters: DealslipDashboardFilters;
  data: DealslipDashboardData;

  constructor() {
    this.filters = new DealslipDashboardFilters();
    this.data = new DealslipDashboardData();
  }
}

export class DealslipData {
  ref: number;
  client: DealslipClientData;
  sellAmount: number;
  sellCurrency: DealslipCurrencyData;
  buyAmount: number;
  buyCurrency: DealslipCurrencyData;
  date: string;
  rate: number;
  status: DealslipStatus;
  createdBy: AdminMiniData;
  lastModifiedBy: AdminMiniData;
  created: string;
  lastModified: string;

  constructor() {
    this.client = new DealslipClientData();
    this.sellCurrency = new DealslipCurrencyData();
    this.buyCurrency = new DealslipCurrencyData();
    this.status = new DealslipStatus();
    this.createdBy = new AdminMiniData();
    this.lastModifiedBy = new AdminMiniData();
  }
}

export class DealslipClientData {
  ref: number;
  firstName: string;
  lastName: string;
  email: string;
  publicKey: string;
  phone: string;
  customerType: 'onboarded' | 'walk-in';
}

export class DealslipCurrencyData {
  ref: number;
  title: string;
  iso: string;
  code: string;
  name: string;
  symbol: string;
}

export class DealslipStatus {
  active: boolean;
  inactive: boolean;
  deleted: boolean;
  new: boolean;
  complete: boolean;
  cancel: boolean;
  pending: boolean;
}

export class DealslipSearchFilters {
  dateFrom: string | null;
  dateTo: string | null;
  status: string | null;
  buyCurrency: string | null;
  sellCurrency: string | null;
  client: DealslipClientData | null;
  createdBy: AdminMiniData | null;
  lastModifiedBy: AdminMiniData | null;
}

export class DealslipDashboardFilters {
  dateFrom: string | null;
  dateTo: string | null;
  client: DealslipClientData | null;
  createdBy: AdminMiniData | null;
  lastModifiedBy: AdminMiniData | null;
}

export class DealslipDashboardData {
  totalDeals: number = 0;
  status: DealslipDashboardStatus;
  sellCurrency: DealslipCurrencySummary[] = [];
  buyCurrency: DealslipCurrencySummary[] = [];

  constructor() {
    this.status = new DealslipDashboardStatus();
  }
}

export class DealslipDashboardStatus {
  new: number = 0;
  pending: number = 0;
  complete: number = 0;
  cancel: number = 0;
}

export class DealslipCurrencySummary {
  currency: DealslipCurrencyData;
  totalDeals: number;
  totalAmount: number;

  constructor() {
    this.currency = new DealslipCurrencyData();
  }
}
